var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeamchat = function SvgTeamchat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m6 14 3.333-2.68z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6 14 3.333-2.68M6 11.333V14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 11.333h-.667A3.334 3.334 0 0 1 2 8V5.333A3.334 3.334 0 0 1 5.333 2h5.334A3.334 3.334 0 0 1 14 5.333V8a3.334 3.334 0 0 1-3.333 3.333H9.333",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6 11.333h-.667A3.334 3.334 0 0 1 2 8V5.333A3.334 3.334 0 0 1 5.333 2h5.334A3.334 3.334 0 0 1 14 5.333V8a3.334 3.334 0 0 1-3.333 3.333H9.333"
  })));
};
export { SvgTeamchat as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiODQ5OWY2MWU2ZWM3YjRiNzQxNDM3N2UzOGUwMjEyMWUuc3ZnIjs=";